<template>
  <div class="h-tab-wrap" :class="$i18n.locale">
    <div :class="['iconfont', icon]"></div>
    <div class="content">{{ label }}: {{ value }}{{ unit }}</div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    }
  }
};
</script>

<style lang="scss">
.h-tab-wrap {
  font-size: 12px;
  width: 184px;
  height: 31px;
  line-height: 31px;

  background: url('~@/assets/image/customs/x1.png') 0 0 / 100% 100% no-repeat;

  display: flex;
  align-items: center;

  .iconfont {
    margin: 0 8px 0 12px;
    font-size: 20px;
  }

  &.en {
    width: 250px;
  }

  &.ar {
    width: 186px;
  }

  &.es {
    width: 280px;
  }

  &.fr {
    width: 260px;
  }

  &.ru {
    width: 284px;
  }

  color: #ffffff;
}
</style>
